import React, { useContext, useEffect, useState } from 'react'
import { t } from '../../i18n/i18n'
import { UseFormReturn } from 'react-hook-form'
import { OrganisationSize, OrganisationType } from '../../api/schemas/schema'
import { IDropdownOption } from '../../interfaces/IDropdownOption'
import { GridItem } from '../../components/common/grid/GridItem'
import { ControlledOrganisationNumberInput } from './ControlledOrganisationNumberInput'
import { ControlledTextInput } from '../../components/common/inputs/TextInput'
import { ControlledOrgDetailsDropDown } from './ControlledOrgDetailsDropDown'
import { ControlledSniDropdown } from './ControlledSniDropdown'
import { Title } from '../../components/common/texts/Title'
import { DataContext } from '../../App'
import { OrganisationWithUserAccountsDTO } from '../../api/schemas/schema'
import { Grid } from '../../components/common/grid/Grid'
import { makeStyles } from '@fluentui/react-components'

const useStyles = makeStyles({
   container: {
      '@media (max-width: 1007px)': {
         display: 'flex',
         flexDirection: 'column',
      },
   },
})

type OrganisationDetailsFormProps = {
   organisationForm: UseFormReturn<OrganisationWithUserAccountsDTO, any, undefined>
   existingOrganisationNumbers: string[]
}

export const OrganisationDetailsForm = ({ organisationForm, existingOrganisationNumbers }: OrganisationDetailsFormProps) => {
   const classes = useStyles()
   const dataContext = useContext(DataContext)
   const [orgTypes, setOrgTypes] = useState<IDropdownOption[]>([])
   const [orgSizes, setOrgSizes] = useState<IDropdownOption[]>([])
   const { organisationSizes, organisationTypes, snis_2007 } = dataContext.state
   const { control, setValue } = organisationForm

   const formatOrgOptions = () => {
      if (organisationSizes && organisationTypes && snis_2007) {
         const sortedOrgSizes = organisationSizes.sort((a, b) => {
            const valueA = a.text.includes('+') ? Number(a.text.split('+')[0]) : Number(a.text.split('-')[0])
            const valueB = b.text.includes('+') ? Number(b.text.split('+')[0]) : Number(b.text.split('-')[0])
            return valueA - valueB
         })

         const mappedOrgSizes: IDropdownOption[] = sortedOrgSizes.map((size: OrganisationType) => ({
            key: size.id,
            text: size.text,
         }))

         const mappedOrgTypes: IDropdownOption[] = organisationTypes.map((type: OrganisationSize) => ({
            key: type.id,
            text: type.text,
         }))

         setOrgSizes(mappedOrgSizes)
         setOrgTypes(mappedOrgTypes)
      }
   }

   useEffect(() => {
      if (organisationSizes?.length && organisationTypes?.length) {
         formatOrgOptions()
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [organisationSizes, organisationTypes])
   return (
      <Grid className={classes.container}>
         <GridItem size={'12/12'}>
            <Title as="h5">{t('OrganisationDetails')}</Title>
         </GridItem>
         <GridItem size={'6/12'}>
            <ControlledOrganisationNumberInput
               existingOrganisationNumbers={existingOrganisationNumbers}
               required
               control={control}
               name={'organisation.organisationNumber'}
               label={t('OrganisationNumber')}
            />
         </GridItem>
         <GridItem size={'6/12'}>
            <ControlledTextInput required control={control} name={'organisation.name'} label={t('CompanyName')} />
         </GridItem>
         <GridItem size={'6/12'}>
            <ControlledOrgDetailsDropDown
               required
               control={control}
               name={'organisation.organisationSize'}
               label={t('OrganisationSize')}
               options={orgSizes}
               setValue={setValue}
            />
         </GridItem>
         <GridItem size={'6/12'}>
            <ControlledOrgDetailsDropDown
               required
               control={control}
               name={'organisation.organisationType'}
               label={t('OrganisationType')}
               options={orgTypes}
               setValue={setValue}
            />
         </GridItem>
         <GridItem size={'12/12'}>
            <ControlledSniDropdown label={t('SNI')} control={control} name="organisation.snIs" options={snis_2007} />
         </GridItem>
      </Grid>
   )
}
